import { render, staticRenderFns } from "./GenderChart.vue?vue&type=template&id=7a9da772"
import script from "./GenderChart.vue?vue&type=script&lang=js"
export * from "./GenderChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports